import { computed, defineComponent, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { environment, isInIframe } from '@/utils/environment';
import { winTopPostMessage } from '@/utils/topWindowBridge';
export default defineComponent({
  name: 'ExamInfoModal',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup: function (props) {
    var loading = ref(false);
    var router = useRouter();
    var route = useRoute();
    var inIframe = isInIframe();
    var onStartExamButtonClick = function () {
      var _a;
      if (inIframe) {
        winTopPostMessage({
          method: 'openUrlOnNewTab',
          data: {
            url: "".concat(location.origin, "/userexam/").concat(props.data.userExamId)
          }
        });
      } else {
        router.push({
          name: 'Examination',
          params: {
            id: props.data.userExamId
          },
          query: ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.ignoreQuery) ? undefined : route.query
        });
      }
    };
    var hideGetCertification = computed(function () {
      return environment === 'production' ? props.data.contestId === 797 : props.data.contestId === 36;
    });
    var isNocFlag = computed(function () {
      return route.query.platform === 'noc';
    });
    var OkText = computed(function () {
      return isNocFlag.value ? '开始比赛' : hideGetCertification.value ? '开始答题' : '开始考试';
    });
    return {
      loading: loading,
      onStartExamButtonClick: onStartExamButtonClick,
      hideGetCertification: hideGetCertification,
      isNocFlag: isNocFlag,
      OkText: OkText
    };
  }
});